export { clearToken, setToken } from "./api/axios"
export * from "./api/generated/EggedApi"
export * from "./api/generated/EggedInterfaces"
export * from "./extractData"
